import {styled} from '@linaria/react';
import {BaseUnstyledLink} from './BaseUnstyledLink';

export const UnstyledLinkLinaria = styled(BaseUnstyledLink)`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
